import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import appSettings from "../configs/appSettings";

declare global {
  interface Window {
    gtag?: (
      key: string,
      trackingId: string,
      config: { page_path: string }
    ) => void;
  }
}

export const useGtagTracker = () => {
  const location = useLocation();

  useEffect(() => {
    if (!window.gtag) return;
    window.gtag("config", appSettings.GtmTagId, { page_path: location.pathname });
  }, [location]);
};
